import React from "react";
import { motion } from "framer-motion";
import { Wrench, Shield, Rocket, Brain, Star, Telescope, Code2, BarChart3, Award } from "lucide-react";

const ICONS = { wrench: Wrench, shield: Shield, rocket: Rocket, brain: Brain, star: Star, telescope: Telescope, code: Code2, chart: BarChart3 };

export const BadgeDisplay = ({ badge, size = "md", earned = true }) => {
  const Icon = ICONS[badge.icon] || Award;
  const dim = size === "sm" ? "h-16 w-16" : size === "lg" ? "h-28 w-28" : "h-20 w-20";
  const iconSize = size === "sm" ? 20 : size === "lg" ? 40 : 28;
  const isRed = badge.color === "red";
  return (
    <motion.div
      whileHover={{ scale: 1.08, rotate: -2 }}
      className={`relative ${dim} flex items-center justify-center shrink-0 ${earned ? "" : "opacity-35 grayscale"}`}
      data-testid={`badge-${badge.module_id || badge.id}`}
    >
      {/* Outer sunburst ring */}
      <div
        className={`absolute inset-0 rounded-full ${
          isRed
            ? "bg-[conic-gradient(from_90deg,#E63946_0deg,#DC2626_60deg,#7f1d1d_120deg,#E63946_180deg,#DC2626_240deg,#7f1d1d_300deg,#E63946_360deg)]"
            : "bg-[conic-gradient(from_90deg,#FFD700_0deg,#FFC107_60deg,#8a6800_120deg,#FFD700_180deg,#FFC107_240deg,#8a6800_300deg,#FFD700_360deg)]"
        } ${earned ? "animate-[spin_14s_linear_infinite]" : ""}`}
      />
      {/* Inner disc */}
      <div className={`absolute inset-[6px] rounded-full ${isRed ? "bg-gradient-to-br from-red-900 to-black" : "bg-gradient-to-br from-[#2a1e00] to-black"} border-2 ${isRed ? "border-red-500/60" : "border-yellow-400/60"} flex items-center justify-center`}>
        <Icon className={isRed ? "text-red-300" : "text-yellow-300"} size={iconSize} strokeWidth={2.4} />
      </div>
      {/* Numeral crest */}
      {badge.module_numeral && (
        <div className={`absolute -bottom-1 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded-full text-[10px] font-display font-black tracking-widest ${isRed ? "bg-red-500 text-white" : "bg-yellow-300 text-black"} border-2 border-black`}>
          {badge.module_numeral}
        </div>
      )}
    </motion.div>
  );
};

export default BadgeDisplay;
